export const config = {
    headers: {
        Authorization: `Bearer ${process.env.REACT_APP_JWT_TOKEN}`
    }
}